import React from "react";
import { Pencil, Trash, ArrowLeft, StarFill } from "react-bootstrap-icons";
import { Badge } from 'react-bootstrap';

import ValuesList from 'components/Values/ValuesList';

import { getNotchIcon } from 'services/notches';

import "./styles.css";

function Details({
    item,
    onEditHandler,
    onDeleteHandler,
    onCloseHandler
}) {
    return (
        <div className="card container-height">

            <div className="card-header form-card-header-paddings no-background no-border">
                <div className="p-2 d-flex justify-content-between">
                    <h3>
                        {getNotchIcon(
                            item.type, 
                            { 
                                className: "ms-auto me-1 flex-shrink-0",
                                color: item.color ?? null, 
                                size: 22 
                            }
                        )} {item.notch}
                    </h3>

                    <div className="d-flex flex-wrap">
                                                             
                        {item.quick_access && (
                            <div className="d-flex align-items-center">
                                <StarFill size={22} className="ms-auto flex-shrink-0" />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="card-body form-card-body-paddings overflow-auto">

                <div className="d-flex justify-content-between mb-3">
                    <span className="text-muted small">{item.date}</span>
                </div>

                {item.tags?.length > 0 && (
                    <div className="mb-3">
                        <h5>Tags</h5>
                        <div className="mt-2 d-flex flex-wrap gap-2 mb-2">
                            {item.tags.map((item) => (
                                <Badge key={item.uid} bg="secondary" className="px-2 py-1 rounded-pill">
                                    {item.name}
                                </Badge>
                            ))}
                        </div>
                    </div>
                )}

                {item.note && (
                    <div className="mb-3">
                        <h5>Note</h5>
                        <div className="mt-2 d-flex flex-wrap gap-2 mb-2">
                            <p className="card-text notch-note-area">
                                {item.note}
                            </p>
                        </div>
                    </div>
                )}

                {item.groups?.length > 0 && (
                    <div className="mb-3">
                        <h5>Groups</h5>
                        <div className="mt-2 d-flex flex-wrap gap-2 mb-2">
                            {item.groups.map((item) => (
                                <Badge key={item.uid} bg="secondary" className="px-2 py-1 rounded-pill">
                                    {item.title}
                                </Badge>
                            ))}
                        </div>
                    </div>
                )}

                {item.values?.length > 0 && (
                    <div className="mb-3">
                        <h5>Values</h5>
                        <div className="mt-2 d-flex flex-wrap gap-2 mb-2">
                            <ValuesList
                                items={item.values}
                            />
                        </div>
                    </div>
                )}
            </div>

            <div className="card-footer form-card-footer-paddings border-top no-background">

                <div className="d-flex justify-content-between">
                    <div className="btn-group">
                        <button
                            className="btn btn-sm btn-outline-danger me-1"
                            onClick={() => onDeleteHandler(item.uid)}
                        >
                            <Trash size={16} />
                        </button>
                        <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => onEditHandler(item)}
                        >
                            <Pencil size={16} />
                        </button>
                    </div>

                    <button
                        type="button"
                        className="btn btn-secondary ms-auto"
                        onClick={(e) => {
                            e.preventDefault();

                            onCloseHandler(null);
                        }}
                    >
                        <ArrowLeft className="me-2" />
                        Back
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Details;
